var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownGettingstarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.042,
    height: 18.283,
    viewBox: "0 0 19.042 18.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M4.032,17.753A.959.959,0,0,1,3.1,16.582l1.159-5.1L.328,8.032A.958.958,0,0,1,.871,6.357l5.2-.472L8.126,1.074a.957.957,0,0,1,1.761,0l2.056,4.812,5.2.472a.958.958,0,0,1,.544,1.675l-3.93,3.446,1.159,5.1a.957.957,0,0,1-1.424,1.034L9.006,14.937,4.523,17.617a.959.959,0,0,1-.491.136Zm4.974-3.971a.96.96,0,0,1,.491.136l4.231,2.531-1.094-4.818a.957.957,0,0,1,.3-.933l3.711-3.254L11.74,7a.956.956,0,0,1-.8-.58L9.006,1.879,7.066,6.419A.954.954,0,0,1,6.273,7l-4.91.446L5.074,10.7a.955.955,0,0,1,.3.934L4.284,16.448l4.231-2.53a.959.959,0,0,1,.491-.136Zm-2.976-7.8v0Zm5.95,0v0Zm0,0",
    transform: "translate(0.515 0.008)",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownGettingstarted);
export default __webpack_public_path__ + "static/media/profiledropdown-gettingstarted.c9d7e300ae653f8be31d7993ce04a979.svg";
export { ForwardRef as ReactComponent };